
export const ENDPOINTS = {
    RefreshToken: 'auth/RefreshToken',
    GetQuotes: 'underwriter/GetQuotes',
    ReferralsAll: 'underwriter/Referrals/All',
    ReferralsPending: 'underwriter/Referrals/Pending',
    ReferralsAssigned: 'underwriter/Referrals/Assigned',
    ReferralsInProgress: 'underwriter/Referrals/InProgress',
    ReferralsEscalated: 'underwriter/Referrals/Escalated',
    ReferralsActioned: 'underwriter/Referrals/Actioned',
    ReferralsCurrent: 'underwriter/Referrals/Current',
    ReferralsFilterQuotes: 'underwriter/Referrals/FilterQuotes',
    GetUnallocatedQuotes: 'underwriter/GetUnallocatedQuotes',
    GetAllocatedQuotes: 'underwriter/GetAllocatedQuotes',
    ViewQuote: 'underwriter/ViewQuote?QuoteNumber=:quoteNumber',
    GetQuotesFromBLDB: 'underwriter/GetQuotesFromBLDB',
    QuoteView: 'quote/View?TransactionId=:transactionId',
    QuotesSearch: 'quote/FreeTextSearch?PageNumber=:pageNumber&PageSize=:pageSize&SearchText=:searchText&TransactionType=:transactionType&TransactionStatus=:transactionStatus&ProductCode=:productCode&LegacySearch=:legacySearch',
    UnderwriterNoteNew: 'underwriter/Notes/New',
    UnderwriterAddInternalNote: 'underwriter/AddInternalNote',
    UnderwriterAddCommunication: 'underwriter/AddCommunication',
    ReferQuote: 'underwriter/ReferQuote',
    CancelPolicy: 'underwriter/Cancel',
    TransferPolicy: 'underwriter/PolicyTransfer',
    TransferPolicyCSVUpload: 'underwriter/PolicyTransfer/UploadCSV',
    ReinstatePolicy: 'underwriter/ReinstatePolicy',
    ProductTypeLabels: 'underwriter/ProductLabels',
    QuoteAction: 'underwriter/QuoteAction',
    QuoteDocumentList: 'underwriter/Documents/QuoteDocumentList?TransactionId=:transactionId&ReferenceCode=:referenceCode',
    PolicyDocumentList: 'underwriter/Documents/PolicyDocumentList?TransactionId=:transactionId&ReferenceCode=:referenceCode',
    GeneratePolicyDocument: 'underwriter/Documents/GeneratePolicyDocument',
    GenerateQuoteDocument: 'underwriter/Documents/GenerateQuoteDocument',
    ClaimsReport: 'underwriter/ClaimsReport',
    ClaimsReportDownload: 'underwriter/ClaimsReport/Download?PolicyNumber=:policyNumber',
    GetUnderwriters: 'underwriter/GetUnderwriters',
    SetReferralAllocation: 'underwriter/SetReferralAllocation',
    AssignQuote: 'underwriter/AssignQuote',
    BrokerCorrespondenceDownloadAttachment: 'underwriter/BrokerCorrespondence/DownloadAttachment?Id=:id&TransactionId=:transactionId&FileName=:fileName&FileExtension=:fileExtension',
    GetRenewals: 'underwriter/Renewals/GetRenewals',
    RenewalLogs: 'underwriter/Renewals/RenewalLogs?PolicyNumber=:policyNumber&PageNumber=:pageNumber',
    GetFilteredRenewals: 'underwriter/Renewals/GetFilteredRenewals',
    UnreleasedRenewals: '/underwriter/Renewals/UnreleasedRenewals?PageNumber=:pageNumber&PageSize=:pageSize&Ascending=:ascending&EffectiveDateFrom=:effectiveDateFrom&EffectiveDateTo=:effectiveDateTo',
    SaveReleaseIndicator: 'underwriter/Renewals/SaveReleaseIndicator',
    RenewalsReplay: 'underwriter/Renewals/Replay',
    RenewalsReferral: 'underwriter/Renewals/UpdateReferOnRenewalDetails',
    RenewalSetHoldStatus: 'underwriter/Renewals/SetOnHoldIndicator',
    RenewalBulkAction: 'renewal/BulkAction',
    GetReferOnRenewalDetails: 'underwriter/Renewals/GetReferonRenewalDetails?PolicyNumber=:policyNumber&RenewalCounter=:renewalCount',
    GenerateRenewal: 'underwriter/Renewals/ManualRenewal',
    CompareQuotes: 'underwriter/CompareQuotes',
    CompareTransactions: 'underwriter/CompareTransactions?BaseTransactionId=:baseTransactionId&ComparedTransactionId=:comparedTransactionId',
    Conditions: 'underwriter/Conditions?ProductCode=:productCode&ConditionLevel=:conditionLevel',
    ActionMessages: 'underwriter/ActionMessages/GetAll',
    CalculatePremium: 'underwriter/CalculatePremium',
    UpdateVulnerableCustomerInfo: 'underwriter/UpdateVulnerableCustomerInfo',
    RollbackTransaction: 'underwriter/RollbackTransaction?PolicyNumber=:policyNumber&RenewalCounter=:renewalCounter&TransactionId=:transactionId',
    GetUsers: 'users/GetUsers',
    EditUser: 'users/EditUser',
    AddUser: 'users/AddUser',
    unblockUser: 'users/UnlockUser',
    DeleteUser: 'users/Delete',
    UserSetActive: 'users/SetActive',
    ExportUsers: 'users/ExportUsers',
    WelcomeEmailCSVUpload: 'users/WelcomeEmail/UploadCSV',
    DistributionBranchDetails: 'admin/DistributionBranchDetails?DistributionBranchId=:distributionBranchId',
    ExternalReferenceSearch: 'quote/ExternalReferenceSearch?PolicyNumber=:policyNumber&QuoteNumber=:quoteNumber&PageNumber=:pageNumber&PageSize=:pageSize',
    ChangeLog: 'quote/ChangeLog?PolicyNumber=:policyNumber&TransactionId=:transactionId&PageNumber=:pageNumber&PageSize=:pageSize',
    UploadFile: 'other/UploadFile',
    UploadInternalAttachment: 'UploadInternalAttachment?TransactionId=:transactionId',
    GetUploadedFile: 'other/GetUploadedFile?Id=:id',
    
    StatsFinance: 'finance/Stats',
    PolicySearch: 'finance/Policies/Search',
    
    FinanceNoteNew: 'finance/v2/FinanceComment',
    RemittanceView: 'finance/v2/Remittance?RemittanceId=:remittanceId',
    RemittanceViewLines: 'finance/v2/Remittance/Lines?RemittanceId=:remittanceId',
    RemittanceAndLinesView: 'finance/v2/RemittanceAndLines?RemittanceId=:remittanceId',
    RemittanceLinesEdit: 'finance/v2/RemittanceLine/Edit',
    RemittanceLinesAdd: 'finance/v2/RemittanceLine/Add',
    RemittanceLinesDelete: 'finance/v2/RemittanceLine/Delete',
    RemittanceLinesSearch: 'finance/v2/RemittanceLine/Search?PageNumber=:pageNumber&PageSize=:pageSize&Ascending=:ascending&SearchText=:searchText&MatchedStatus=:matchedStatus&Stage=:stage&Amount=:amount&AbsoluteAmount=:absolute',
    RemittanceAdviceFileDownload: 'finance/v2/Remittance/File?RemittanceId=:id',
    RemittanceAdviceCsvDownload: 'finance/v2/Remittance/CSV?RemittanceId=:id',
    RemittanceEdit: 'finance/v2/Remittance/Edit',
    RemittanceAdviceUpload: 'finance/v2/Remittance/Upload',
    BankStatementUpload: 'finance/v2/BankStatement/Upload',
    BankStatementLineUpdateStage: 'finance/v2/BankStatementLine/UpdateStage',
    BankStatementLineSearch: 'finance/v2/BankStatementLine/Search?PageSize=:PageSize&PageNumber=:PageNumber&Ascending=:Ascending&PartialNarrative=:PartialNarrative&MatchedStatus=:MatchedStatus&Stage=:Stage&Credit=:Credit',
    BankStatementLinesDelete: 'finance/v2/BankStatementLine/Delete?BankStatementLineId=:bankStatementId',
    RemittanceDelete: 'finance/v2/Remittance/Delete?RemittanceId=:remittanceId',
    RemittancesSearch: 'finance/v2/Remittance/Search?PageNumber=:pageNumber&PageSize=:pageSize&Ascending=:ascending&MatchedStatus=:matchedStatus&Stage=:stage&PartialFileName=:partialFilename&Amount=:amount',
    RemittanceAddManual: 'finance/v2/Remittance/Add',
    RemittancesEmailActivity: 'finance/v2/Remittance/Emailed?PageNumber=:pageNumber&PageSize=:pageSize&PartialSubject=:subject&ExtractStatus=:status&Amount=:amount',
    RemittanceLinePark: 'finance/v2/RemittanceLine/Park?RemittanceLineId=:remittanceLineId',
    RemittanceLineUnPark: 'finance/v2/RemittanceLine/Unpark?RemittanceLineId=:remittanceLineId',
    RemittanceLinesIncorrectFundsEmailMetadata: 'finance/v2/IncorrectFundsEmail/Preview?RemittanceLineId=:remittanceLineId',
    RemittanceLinesSendIncorrectFundsEmail: '/finance/v2/IncorrectFundsEmail/Send',
    RemittanceLinesSendUnmatchedFundsEmail: 'finance/v2/UnmatchedFundsEmail/Send',
    RemittanceAutomatch: 'finance/v2/Remittance/AutoMatch?RemittanceId=:remittanceId&RunInBackground=true',
    ManualMatchRemittanceToBankStatementLine: 'finance/v2/Remittance/ManualMatch',
    ManualMatchResetPolicies: 'finance/v2/Policy/Reset',
    UnmatchRemittanceAndLines: 'finance/v2/Remittance/Unmatch?RemittanceId=:remittanceId',
    UnmatchRemittanceLine: 'finance/v2/RemittanceLine/Unmatch',
    OffsystemMatch: 'finance/v2/RemittanceLine/OffSystemMatch',
    ProcessMailboxIncomingMsgs: 'finance/v2/Remittance/ScanInbox',
    PolicyPaymentDetails: 'finance/v2/Policy/Invoices?PolicyNumber=:policyNumber',
    InvoiceDeferment: 'finance/v2/Invoice/SetDeferment',
    PolicyPremiumDetails: 'finance/v2/Policy/PremiumDetails?TransactionId=:transactionId',
    ManualMatchRemittanceLineToPolicy: 'finance/v2/RemittanceLine/ManualMatch',
    RemittanceLinesView: 'finance/v2/RemittanceLine?RemittanceLineId=:remittanceLineId',
    
    CreateBLUser: 'users/CreateBLUser',
    GetBLUserDetailsEmail: 'users/GetBLUserDetails?Email=:email',
    GetBLUserDetailsId: 'users/GetBLUserDetails?UserId=:userId',
    MessageTemplates: 'MessageTemplates?ActionType=:actionType&MessageType=:messageType&ProductCode=:productCode',
};

export const getEndpoint = (path, params, absolute) => {
    Object.keys(params).forEach(key => {
        path = path.replaceAll(`:${key}`, params[key]);
    });

    if (absolute) {
        return `${process.env.REACT_APP_API_BASE}/${path}`;
    } else {
        return path;
    }
};


export const getEndpointRemoveEmptyParams = (path, params, absolute) => {
    let matchPath = getEndpoint(path, params, absolute);
    
    const matches = matchPath.matchAll(/(\?|&)([^&]*)=(?=&|$)/g);
    // console.log(matches, matchPath)
    matches.forEach(match => {
        matchPath = matchPath.replace(new RegExp(`${match[2]}=&?`), '');
    });
    return matchPath;
};